<template>
    <div class="w-full">
        <div class="w-full mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    MONITORING PENGADAAN OBAT >> LUNAS
                </h1>
            </div>
            <div class="w-full md:w-1/2 mt-5 mb-5 mx-auto">
                <DateInput
                    v-model="tglAwalData"
                    class="w-full grow mr-5"
                    id="tgl-awal"
                    label="PILIH TANGGAL AWAL"
                />
            </div>
            <div class="w-full md:w-1/2 mt-5 mb-5 mx-auto">
                <DateInput
                    v-model="tglAkhirData"
                    class="w-full grow mr-5"
                    id="tgl-akhir"
                    label="PILIH TANGGAL AKHIR"
                />
            </div>
            <div class="w-full md:w-1/2 mx-auto">
                <button
                    @click.prevent="getPengadaanObatYangLunas()"
                    class="bg-green-600 hover:bg-green-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center ml-auto self-end w-36 h-10 text-xs"
                >
                    CARI
                </button>
            </div>
            <div class="w-full my-3">

                <div class="border-2 border-black rounded-md p-5 mb-3">
                    <p  class="font-bold tracking-wider text-lg md:text-lg  mb-5">Daftar Pengadaan Obat Yang Sudah Lunas</p>
                    <div
                        class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300 mb-8"
                    >
                        <table class="w-full whitespace-nowrap">
                            <thead>
                                <tr class="text-left font-bold bg-amber-100">
                                    <th class="py-2 px-3 text-center text-sm">
                                        Aksi
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        No.PO
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Tanggal PO
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        No. DO
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Tanggal DO
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        No. Faktur
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Tanggal Faktur
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        No. ULP
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Tanggal ULP
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        No. Bayar
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Tanggal Bayar
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    class="hover:bg-gray-100"
                                    v-for="data in pengadaanObatYangLunasData.lunas"
                                >
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                       
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >
                                       {{ data.fs_kd_trs }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >   
                                        {{ data.fd_tgl_trs }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >   
                                        {{ data.kdDO }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >   
                                        {{ data.tglDO }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >   
                                        {{  data.no_faktur }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >   
                                        {{  data.tgl_faktur }}
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >   
                                        
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >   
                                       {{ data.fd_tgl_ulp_berkas_selesai }} 
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >   
                                        
                                    </td>
                                    <td
                                        class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"
                                    >   
                                        {{ data.fd_tgl_byr }}
                                    </td>
                                </tr>
                                <tr
                                    class="bg-white hover:bg-gray-100 focus-within:bg-gray-100"
                                     v-if="pengadaanObatYangLunasData && pengadaanObatYangLunasData.lunas.length == 0"
                                >
                                    <td
                                      
                                        class="border-r border-t text-sm select-none cursor-pointer pl-2"
                                        colspan="11"
                                    >
                                        Belum ada data order obat yang sudah lunas
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

             
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutAdminBig from "../../../Shared/LayoutAdminBig.vue";
import RandomShape from "../../../Shared/RandomShape.vue";
import DateInput from "../../../Shared/DateInput.vue";
import TextInput from "../../../Shared/TextInput.vue";
import SelectInput from "../../../Shared/SelectInput.vue";
export default {
    components: {
        Link,
        RandomShape,
        DateInput,
        TextInput,
        SelectInput,
    },
    data() {
        return {
            tglAwalData: this.tglAwal,
            tglAkhirData: this.tglAkhir,
            pengadaanObatYangLunasData: this.pengadaanObatYangLunas,
            // timerCount: 600,
        };
    },
    watch: {
        // timerCount: {
        //     handler(value) {
        //         if (value > 0) {
        //             setTimeout(() => {
        //                 this.timerCount--;
        //             }, 1000);
        //         } else {
        //             this.getPasienIgd();
        //         }
        //     },
        //     immediate: true,
        // },
    },
    props: {
        tglAwal: String,
        tglAkhir: String,
        pengadaanObatYangLunas: Object,
    },
    methods: {
        getPengadaanObatYangLunas() {
            this.$inertia.get(
                "/admin/pengadaan_obat_yang_lunas/ajax",
                {
                    tglAwal: this.tglAwalData,
                    tglAkhir: this.tglAkhirData
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        // this.timerCount = 600;
                        this.pengadaanObatYangLunasData = page.props.additional.pengadaanObatYangLunas;
                    },
                }
            );
        },
        // exportExcel(){
        //     location.href = '/admin/rekap_pasien_ranap_per_kelas/export/excel?tgl='+this.tglData;
        // }
    },
    layout: LayoutAdminBig,
};
</script>
